__turbopack_context__.v({
  "amount": "DefaultTitle-module-scss-module__aWyhqq__amount",
  "icon": "DefaultTitle-module-scss-module__aWyhqq__icon",
  "title": "DefaultTitle-module-scss-module__aWyhqq__title",
  "title_text": "DefaultTitle-module-scss-module__aWyhqq__title_text",
  "wrap": "DefaultTitle-module-scss-module__aWyhqq__wrap",
});
